/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Heading/theme';

export const HeadingTheme = theme;
